import { Container } from 'react-bootstrap';
import Layout from '../../layout';
import UserDataGrid from '../features/UserDataGrid';

const UserListPage = () => (
  <Layout>
    <Container className="h-100 d-flex flex-column flex-fill">
      <UserDataGrid />
    </Container>
  </Layout>
);

export default UserListPage;
